import styled, { CSSProperties } from 'styled-components';

import {
  flex,
  FlexProps,
  gap,
  GapProps,
  margin,
  MarginProps,
  padding,
  PaddingProps,
  rect,
  RectProps,
} from '../../../components/styles';

type Props = FlexProps &
  MarginProps &
  PaddingProps &
  GapProps &
  RectProps & {
    overflow?: CSSProperties['overflow'];
    order?: CSSProperties['order'];
    sp?: 'column' | 'row';
  };

export const Flex = styled.div<Props>`
  display: flex;
  overflow: ${({ overflow }) => overflow};
  order: ${({ order }) => order};
  ${flex};
  ${margin};
  ${padding};
  ${gap};
  ${rect};

  ${({ theme, sp }) => {
    return {
      ...theme.screen.sp({
        flexDirection: sp == 'column' ? 'column' : sp == 'row' ? 'row' : null,
      }),
    };
  }})
`;
